import PropTypes from 'prop-types'

import { addressPropTypes } from '../../../common/propTypes'
import { Link, Divider, Box } from '@mui/material'
import AddressSection from './AddressSection'
import useTranslations from '../../../i18n/useTranslations'

import styles from './styles'

const AddressSectionOrigin = ({ data, onClickChange }) => {
  const t = useTranslations()
  return (
    <>
      <AddressSection title={t('shipping-send-form:origin-mobile')} data={data}>
        <Box sx={styles.addresSectionButtonWrapper}>
          <Divider sx={styles.addresSectionDivider} />
          <Link component="button" onClick={onClickChange}>
            {t('action:change')}
          </Link>
        </Box>
      </AddressSection>
    </>
  )
}

AddressSectionOrigin.propTypes = {
  data: addressPropTypes,
  onClickChange: PropTypes.func,
}

export default AddressSectionOrigin
